import { render, staticRenderFns } from "./DoctorRegisterModal.vue?vue&type=template&id=05c99481&"
import script from "./DoctorRegisterModal.vue?vue&type=script&lang=ts&"
export * from "./DoctorRegisterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports